<template>
	<div>
		<el-dialog :visible.sync="dialogFormVisible" width="498px" top="17vh" :lock-scroll="false" :close-on-click-modal="false">
			<div slot="title" class="dialog-header">
				<div class="dialog-header-logo">
					<img src="../assets/img/login/login.png" />
				</div>
				<div class="dialog-header-tab">
					<div class="tab-1" :class="activeTab==0?'tab-1-active':''" @click="changeTab(0)">{{$t('login.login27')}}</div>
				</div>
			</div>
			<el-form :model="form">
				<div v-if="activeTab==0">
					<el-form-item :error="erroraccount">
						<el-input v-model="form.account" :placeholder="$t('login.login28')" autoComplete="new-password" clearable></el-input>
					</el-form-item>
					<el-form-item :error="errorcode">
						<el-input v-model="form.code" @input="handleInput" maxlength="6" :placeholder="$t('login.login29')" autoComplete="new-password">
							<el-button type="text" :loading="loadingCode" slot="append"  :class="form.account?'input-code-active':''" class="input-code" @click="getcode()">{{codeText.length>5?$t(`${codeText}`):codeText}}</el-button>
						</el-input>
					</el-form-item>
					<el-form-item :error="errorpassword">
						<el-input :type="pwType" v-model="form.password"  :οnkeyup="form.password = form.password.replace(/[\u4e00-\u9fa5 ]/ig,'')"   :maxlength="16" :placeholder="$t('login.login30')" autoComplete="new-password">
							<img v-if="pwType=='password' && form.password" @click="changePw('text')" src="../assets/img/login/see.png" style="width: 20px;height: 20px;margin-top: 13px;margin-right: 5px;cursor: pointer;" slot="suffix"/>
							<img v-if="pwType=='text' && form.password" @click="changePw('password')"   src="../assets/img/login/see2.png" style="width: 20px;height: 20px;margin-top: 13px;margin-right: 5px;cursor: pointer;" slot="suffix"/>
							
						</el-input>
					</el-form-item>
					<el-form-item :error="errorpassword2">
						<el-input :type="pwType2" v-model="form.password2"  :οnkeyup="form.password2 = form.password2.replace(/[\u4e00-\u9fa5 ]/ig,'')"  :maxlength="16" :placeholder="$t('login.login31')" autoComplete="new-password">
							<img v-if="pwType2=='password' && form.password2" @click="changePw2('text')" src="../assets/img/login/see.png" style="width: 20px;height: 20px;margin-top: 13px;margin-right: 5px;cursor: pointer;" slot="suffix"/>
							<img v-if="pwType2=='text' && form.password2" @click="changePw2('password')"   src="../assets/img/login/see2.png" style="width: 20px;height: 20px;margin-top: 13px;margin-right: 5px;cursor: pointer;" slot="suffix"/>
	
						</el-input>
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<div class="dialog-footer-button">
					<el-button type="primary"  :loading="loadinglogin"  @click="login()">{{$t('login.login32')}}</el-button>
				</div>
				<div class="dialog-footer-bottom">
					<div class="to-login" @click="toLogin()">{{$t('login.login33')}}</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import areas from "../../common/areas";
	import { getLogin , getLoginCode , getSendMSM , getforgotPW } from "../../common/api";
	import md5 from "js-md5";
	import { filters } from "../../common/filters.js";
	export default {
		components: {},
		props: {
		},
		data() {
			return {
				pwType:'password',
				pwType2:'password',
				dialogFormVisible:false,
				activeTab:0,
				form: {
					account: '',
					password: '',
					password2:'',
					code:'',
				},
				codeText:'login.login14',
				value: '+86',
				options: areas,
				timer: 60,
				verification: true,
				erroraccount:'',
				errorpassword:'',
				errorpassword2:'',
				errorcode:'',
				language: 'zh',
				auth_timer:null,
				loadingCode:false,
				loadinglogin:false,
			};
		},
		computed: {},
		watch: {
			'form.account':{
				handler:function (val,old){
					if(val==''){
						this.erroraccount='';
					}
					var reg=filters.regPwd(1);
					if(reg.test(val)){
						this.erroraccount='';
					}
				}
			},
			'form.code':{
				handler:function (val,old){
					if(val=='' || val.length==4){
						this.errorcode='';
					}
				}
			},
			'form.password':{
				handler:function (val,old){
					if(val==''){
						this.errorpassword='';
					}
					var reg=filters.regPwd(0);
					if(reg.test(val)){
						this.errorpassword='';
					}
				}
			},
			'form.password2':{
				handler:function (val,old){
					if(val==''){
						this.errorpassword2='';
					}
					var reg=filters.regPwd(0);
					if(reg.test(val)){
						this.errorpassword2='';
					}
				}
			}
		},
		created() {

		},
		mounted() {
			let lang = localStorage.getItem('lang') || filters.getLocale();
			this.language = lang;
		},
		methods: {
			changePw(type){
				this.pwType=type;
			},
			changePw2(type){
				this.pwType2=type;
			},
			handleInput(value) {
			  const reg = /^[\d\.]+$/;
			  if (value && !reg.test(value)) {
				this.form.code = value.replace(/[^\d\.]/g, '');
			  }
			},
			init(){
				this.form.account='';
				this.form.password='';
				this.form.password2='';
				this.form.code='';
				this.verification =true;
				this.codeText='login.login14';
				clearInterval(this.auth_timer);
			},
			changeTab(index){
				this.activeTab=index;
				this.form.account='';
				this.form.password='';
				this.form.code='';
			},
			toLogin(){
				this.init();
				this.dialogFormVisible=false;
			},
			login(){
				const params={
					"account": this.form.account.trim(),
					"code": this.form.code,
					"pwd": md5(this.form.password.trim())
				}
				if(this.form.account==''){
					this.erroraccount=this.$t('login.login16');
					return;
				}else{
					this.erroraccount='';
				}
				var reg=filters.regPwd(1);
				if(!reg.test(this.form.account)){
					this.erroraccount=this.$t('register.register18');
					return;
				}else{
					this.erroraccount='';
				}
				
				if(this.form.code==''){
					this.errorcode=this.$t('login.login19');
					return;
				}else{
					this.errorcode='';
				}
				
				if(this.form.password==''){
					this.errorpassword=this.$t('login.login17');
					return;
				}else{
					this.errorpassword='';
				}
				var reg= filters.regPwd(0);
				if(!reg.test(this.form.password)){
					this.errorpassword=this.$t('register.register20');
					return;
				}else{
					this.errorpassword='';
				}
				
				if(this.form.password2==''){
					this.errorpassword2=this.$t('login.login17');
					return;
				}else{
					this.errorpassword2='';
				}
				var reg= filters.regPwd(0);
				if(!reg.test(this.form.password2)){
					this.errorpassword2=this.$t('register.register20');
					return;
				}else{
					this.errorpassword2='';
				}
				if(this.form.password!=this.form.password2){
					this.errorpassword2=this.$t('register.register22');
					return;
				}else{
					this.errorpassword2='';
				}
				this.loadinglogin=true;
				getforgotPW(params).then((res) => {
					this.loadinglogin=false;
					if(res.code==0){
						this.$message({
						   showClose: true,
						   message: this.$t('login.login34'),
						   type: 'success'
						});
						this.dialogFormVisible=false;
						// localStorage.setItem('loginState', res.data.token_info.access_token);
						// this.$parent.loginState=true;
						// this.$parent.getUserInfoData();
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			getcode(index){
				let params={
					"account": this.form.account.trim(),
					//"country_code": this.value,
					"sms_type": 3,//1注册  2 登录  3忘记密码
					"code_size": 6,
				};
				if(this.form.account==''){
					this.erroraccount=this.$t('login.login16');
					return;
				}else{
					this.erroraccount='';
				}
				var reg=filters.regPwd(1);
				if(!reg.test(this.form.account)){
					this.erroraccount=this.$t('register.register18');
					return;
				}else{
					this.erroraccount='';
				}
				if(!this.verification){
					return
				}
				this.loadingCode=true;
				getSendMSM(params).then((res) => {
					this.loadingCode=false;
					if(res.code==0){
						this.$message({
						   showClose: true,
						   message: this.$t('login.login20'),
						   type: 'success'
						});
						this.form.code=res.data.code;
						this.verification = false;
						setTimeout(() => {
							this.timer = 60;
							this.codeText=this.timer+'s';
							
							this.countDown();
						}, 1000);
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			countDown() {
				this.auth_timer = setInterval(() => {
					this.timer--;
					this.codeText=this.timer+'s';
					if (this.timer <= 0) {
						this.codeText='login.login14';
						this.verification = true;
						clearInterval(this.auth_timer);
					}
				}, 1000);
			},
		},
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-input__inner{
		border: none !important;
	}
	::v-deep .el-input-group__append{
		border: none !important;
	}
	::v-deep .el-form-item__content{
		border: 1px solid #E5E5E5;
		border-radius: 4px;
	}
	::v-deep .el-input__suffix-inner{
		// border-right: 1px solid #E5E5E5;
		// padding-right: 7px;
	}
	
	::v-deep .el-popup-parent--hidden{
		padding-right: 0 !important;
	}
	
	::v-deep .el-dialog__body{
		padding: 30px 44px 16px !important;
	}
	::v-deep .dialog-footer .el-button{
		width: 410px;
		height: 45px;
		background: #10B1A7;
		border-radius: 4px 4px 4px 4px;
		
		font-family: Source Han Sans CN, Source Han Sans CN;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 16px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
	::v-deep .el-button--primary{
		    border-color: #10B1A7 !important;
	}
	::v-deep .el-input__inner{
		border: 1px solid #E5E5E5;
	}
	::v-deep .el-input__inner:focus {
		border-color: #E5E5E5;
	}
	::v-deep .el-dialog__header{
		padding: 10px 44px 0 !important;
	}
	::v-deep .el-dialog__footer{
		padding: 10px 44px  32px !important;
	}
	::v-deep .el-dialog__headerbtn{
		top: 30px !important;
	}
	::v-deep .el-dialog__headerbtn .el-dialog__close{
		font-size: 24px !important;
		color: #909399 !important;
	}
	
	
	::v-deep  .el-input__inner{
		height: 45px;
		line-height: 45px;
	}
	::v-deep  .el-input-group__prepend{
		width: 150px;
		padding: 0 0 0 16px!important;
		
		font-family: Source Han Sans CN, Source Han Sans CN;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		line-height: 16px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	::v-deep  .el-select{
		width: 90px;
		margin: -10px 0 !important;
	}
	::v-deep  .el-input-group__prepend{
		background: #FFF !important;
		border: none !important;
	}
	::v-deep .el-input-group__append{
		background-color: #FFFFFF;
	}
	
	::v-deep .el-form-item{
		margin-bottom: 34px;
	}
	.input-code-active{
		color: #10B1A7 !important;
	}
	.dialog-header{
		margin-top: 18px;
	}
	.dialog-header-logo{
		width: 52px;
		height: 42px;
		margin-bottom: 24px;
		img{
			width: 52px;
			height: 42px;
		}
	}
	.dialog-header-tab{
		display: flex;
		.tab-1{
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 400;
			font-size: 20px;
			color: #333333;
			line-height: 23px;
			text-align: left;
			font-style: normal;
			text-transform: none;
			margin-right: 48px;
			cursor: pointer;
		}
		.tab-1-active{
			color: #10B1A7;
			position: relative;
		}
		.tab-1-active::before{
			content: "";
			position: absolute;
			left: 20%;
			right: 20%;
			height: 3px;
			bottom: -10px;
			background-color: #10B1A7;
		}
	}
	.dialog-footer{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		.dialog-footer-bottom{
			display: flex;
			flex-direction: column;
			margin-top: 12px;
			width: 100%;
			.to-login{
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 14px;
				color: #10B1A7;
				line-height: 16px;
				text-align: center;
				font-style: normal;
				text-transform: none;
				cursor: pointer;
			}
			.dialog-footer-button{
				
			}
			.dialog-footer-agreement{
				display: flex;
				justify-content: space-between;
				.forgot-password{
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 400;
					font-size: 14px;
					color: #999999;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					text-transform: none;
					cursor: pointer;
				}
				.register{
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 400;
					font-size: 14px;
					color: #10B1A7;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					text-transform: none;
					cursor: pointer;
				}
			}
			.dialog-footer-agreement-tips{
				display: flex;
				justify-content: center;
				margin-top: 24px;
				
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 12px;
				color: #333333;
				line-height: 14px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.dialog-footer-agreement-tips .active{
				color: #10B1A7;
				cursor: pointer;
			}
		}
	}
	
	.input-code{
		font-family: Source Han Sans CN, Source Han Sans CN;
		font-weight: 400;
		font-size: 14px;
		color: #999999;
		line-height: 16px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		cursor: pointer;
		border-left: 1px solid #E5E5E5 !important;
		padding-left: 21px;
		border-radius: 0;
		margin: 0px 3px !important;
	}
	.input-hr{
		height: 30px;
		width: 1px;
		color: #E5E5E5;
	}
	.input-code:hover{
		color: #10B1A7;
	}
</style>